module.exports = __webpack_public_path__ + "static/media/facebook-theme-icon.7487f28c.svg";